<template>
    <div
        ref="scrollList"
        :style="{ backgroundColor: colors.messageList.bg }"
        class="sc-message-list"
        @scroll="handleScroll"
    >
        <Message
            v-for="(message, idx) in filteredMessages"
            :id="`sc-message_${$_.get(message, 'id') || $_.get(message, 'raw.uniqMessageId') || idx}`"
            :key="`sc-message_${$_.get(message, 'id') || $_.get(message, 'raw.uniqMessageId') || idx}`"
            :colors="colors"
            :is-chat-window="ischatwindow"
            :is-private-chat="isPrivateChat"
            :is-colored="isColored"
            :message="message"
            :random-bg-color-with-name="randomBgColorWithName"
            :showAvatar="showAvatar"
            :user="profile(message)"
            @remove="$emit('remove', message)"
            @reply-comment-action="$emit('reply-comment-action', $event)"
            :disable-translation="disableTranslation"
            :is-whatsapp="isWhatsapp"
            :channel-id="channelId"
            :contextMenu="$_.get(message, 'raw.isVisible', contextMenuVisable) && contextMenuVisable"
            :context-menu-only-create-task="contextMenuOnlyCreateTask"
            :user-message-color="computedUserMessageColor"
            :debugModeEnabled="debugModeEnabled"
            :class="{
                hiddenMessage: isOwnedByRequestUser ? false : !$_.get(message, 'raw.isVisible', true),
            }"
            :visitorId="visitorId"
        >
            {{ message }}
            <template v-slot:user-avatar="scopedProps">
                <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
            </template>
            <template v-slot:text-message-body="scopedProps">
                <slot
                    :me="scopedProps.me"
                    :message="scopedProps.message"
                    :messageColors="scopedProps.messageColors"
                    :messageText="scopedProps.messageText"
                    name="text-message-body"
                >
                </slot>
            </template>
            <template v-slot:text-message-toolbox="scopedProps">
                <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
            </template>
        </Message>
        <div v-if="newMsg && ischatwindow" class="newMsg" @click="_scrollDown">
            <md-icon>expand_more</md-icon>
        </div>
    </div>
</template>

<script>
import { socketMessageStream } from "../../utils/socketStream";
import { filter } from "rxjs/operators";
import { mapState } from "vuex";

import Message from "./Message.vue";
import chatIcon from "./assets/chat-icon.svg";
import _ from "lodash";

export default {
    name: "MessageList",
    components: {
        Message,
    },
    props: {
        visitorId: {
            type: String,
            required: false,
        },
        contactOwner: {
            type: String,
            required: false,
        },
        shouldScroll: {
            type: Boolean,
            required: false,
            default: true,
        },
        disableTranslation: {
            type: Boolean,
            default: false,
            required: false,
        },
        ischatwindow: {
            type: Boolean,
            default: false,
        },
        participants: {
            type: Array,
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        scrollTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAvatar: {
            type: Boolean,
            required: false,
            default: false,
        },
        randomBgColorWithName: {
            type: Boolean,
            required: false,
            default: false,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        isPrivateChat: {
            type: Boolean,
            default: false,
            required: false,
        },
        isWhatsapp: {
            type: Boolean,
            default: false,
            required: false,
        },
        channelId: {
            type: String,
            required: false,
        },
        contextMenuVisable: {
            type: Boolean,
            default: true,
            required: false,
        },
        /** true ise sağ tık menüsünde sadece "Görev oluştur" seçeneği gösterilir (örn. Archives) */
        contextMenuOnlyCreateTask: {
            type: Boolean,
            default: false,
            required: false,
        },
        debugModeEnabled: {
            type: Boolean,
            default: false,
            required: false,
        },
        showChatbotPrivate: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    data() {
        return {
            newMsg: false,
            isScrolled: false,
            sub: null,
            bgColorList: [
                "#9370DB",
                "#FFD700",
                "#FF6347",
                "#00CED1",
                "#9370DB",
                "#40E0D0",
                "#FF4500",
                "#6A5ACD",
                "#87CEEB",
                "#FF69B4",
                "#20B2AA",
                "#FFA07A",
                "#00FF7F",
                "#8A2BE2",
                "#FF6347",
            ],
            textColorList: [
                "#333333",
                "#333333",
                "#FFFFFF",
                "#333333",
                "#FFFFFF",
                "#333333",
                "#FFFFFF",
                "#FFFFFF",
                "#333333",
                "#333333",
                "#333333",
                "#333333",
                "#333333",
                "#FFFFFF",
                "#FFFFFF",
            ],
            userList: [],
        };
    },
    methods: {
        sentColorsStyle() {
            const colorIndex = this.getUserColorIndex();
            return {
                color: this.textColorList[colorIndex % this.textColorList.length],
                backgroundColor: this.bgColorList[colorIndex % this.bgColorList.length],
            };
        },
        getUserColorIndex() {
            this.getUserList();
            const userIndex = this.userList.findIndex((user) => user._id === this.user._id);
            return userIndex % this.bgColorList.length;
        },
        receivedColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
            };
        },
        getUserList() {
            const messageList = this.messages.filter(
                (message) => typeof message.type !== "undefined" && message.type === "text"
            );
            const message = messageList[messageList.length - 1];
            const conversationId = message?.raw?.conversation;
            const conversation = this.chats.find((chat) => chat._id === conversationId);

            if (conversation?.meta?.chatType === "team") {
                this.userList = this.users;
            } else if (this.selectedChat && this.selectedChat.meta && this.selectedChat.meta?.department) {
                this.userList = this.users.filter((user) => {
                    return user.subjects.includes(this.selectedChat.meta?.department._id) || user.subjects.length === 0;
                });

                this.userList = this.userList.map((user) => {
                    return {
                        ...user,
                    };
                });
            } else if (conversation?.meta?.chatType === "groupThread") {
                this.userList = conversation.meta?.groupThread.agents.reduce(
                    (result, agent) => {
                        result.push(agent);
                        return result;
                    },
                    [conversation.meta?.groupThread.creator]
                );
            }
        },

        _scrollDown() {
            if (this.$refs.scrollList) {
                this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
                this.newMsg = false;
                this.isScrolled = false;
            }
        },
        handleScroll(e) {
            if (this.shouldScroll) {
                if (e.target.scrollTop === 0) {
                    this.$emit("scrollToTop");
                }
                if (
                    !!this.$refs.scrollList &&
                    this.$refs.scrollList.scrollTop >
                        this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100
                ) {
                    this.newMsg = false;
                    this.isScrolled = false;
                } else {
                    this.isScrolled = true;
                    if (!this.newMsg) this.newMsg = true;
                }
            }
        },
        shouldScrollToBottom() {
            if (this.alwaysScrollToBottom) {
                return (
                    (this.alwaysScrollToBottom ||
                        (!!this.$refs.scrollList &&
                            this.$refs.scrollList.scrollTop >
                                this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100)) &&
                    (!this.isScrolled || !this.ischatwindow)
                );
            }
        },
        profile(message) {
            return { _id: message.raw?.user?._id || message.raw?.userId, name: message.author };
        },
    },
    computed: {
        ...mapState({
            activeConversation: (state) => state.contact.selectedContact?.lastConversation,
            lastPrivateMessage: (state) => state.app.lastPrivateChat,
            unreadCount: (state) => state.app.unreadPrivateChatCount,
            users: (state) => state.user.users.data,
            chats: (state) => state.team.chats,
            selectedChat: (state) => state.team.selectedChat,
            user: (state) => state.auth.user,
            hideSystemMessages: (state) => state.app.hideSystemMessages,
        }),
        computedUserMessageColor() {
            return this.sentColorsStyle();
        },
        defaultChatIcon() {
            return chatIcon;
        },
        isOwnedByRequestUser() {
            return this.contactOwner ? this.contactOwner === this.$store.state.auth.user?._id : false;
        },
        filteredMessages() {
            if (this.hideSystemMessages) {
                return this.messages.filter((message) => {
                    const messageType = message.raw?.messageType;
                    if (messageType === "chatbot-private" && this.showChatbotPrivate) return true;
                    return messageType !== "system" && messageType !== "chatbot-private";
                });
            }
            return this.messages;
        },
    },
    mounted() {
        if (!this.scrollTop && !this.isScrolled) {
            this.$nextTick(this._scrollDown());
        }
        if (!this.ischatwindow && !this.isPrivateChat) {
            this.sub = socketMessageStream
                .pipe(
                    filter(
                        (x) =>
                            ["visitor", "user"].includes(_.get(x, "data.messageType")) &&
                            this.activeConversation !== null &&
                            x.data.conversationId === this.activeConversation._id
                    )
                )
                .subscribe(() => {
                    if (this.isScrolled) this.newMsg = true;
                });
        }
    },
    updated() {
        if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
    },
    beforeDestroy() {
        if (this.sub) this.sub.unsubscribe();
    },
    watch: {
        messages(newVal) {
            if (newVal) {
                this.getUserList();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.sc-message-list {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-size: 100%;
    padding: 40px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .hiddenMessage {
        content: "";
        filter: blur(10px);
        user-select: none;
    }

    .newMsg {
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 2;
        padding: 2.5px;
        border-radius: 50%;
        background-color: #22272d;
        cursor: pointer;

        .md-icon.md-theme-default.md-icon-font {
            color: #ffffff;
        }
    }
}
</style>
